module.exports = {
  __depends__: [ require(108) ],
  __init__: [ 'touchInteractionEvents' ],
  touchInteractionEvents: [ 'type', require(170) ],
  touchFix: [ 'type', require(169) ]
};